import { TriangleAlert, ShieldAlert } from 'lucide-react';

import { DepositStatusEnum, SyncStatusEnum } from 'src/graphql/schema';
import { Tooltip, TooltipContent, TooltipTrigger, TooltipProvider } from '@/components/ui/tooltip';
import { cn } from 'src/lib/utils';

type ErrorTooltipProps = {
  children: React.ReactNode;
  error?: string;
};

const ErrorTooltip = ({ children, error }: ErrorTooltipProps) => (
  <TooltipProvider delayDuration={100}>
    <Tooltip>
      <TooltipTrigger asChild className={cn(error ? 'cursor-pointer' : 'pointer-events-none')}>
        {children}
      </TooltipTrigger>
      <TooltipContent
        side="top"
        align="center"
        className="max-w-[249px] bg-white text-sm text-popover-foreground shadow-md"
      >
        {error}
      </TooltipContent>
    </Tooltip>
  </TooltipProvider>
);

type Props = {
  depositStatus: DepositStatusEnum;
  syncStatus?: SyncStatusEnum | null;
  error?: string;
};

const AssetAlert = ({ depositStatus, syncStatus, error }: Props) => {
  if (depositStatus === DepositStatusEnum.Error)
    return (
      <ErrorTooltip error={error}>
        <ShieldAlert className="text-red-500 focus:text-red-500 size-4" />
      </ErrorTooltip>
    );

  if (syncStatus === SyncStatusEnum.Disconnected)
    return (
      <ErrorTooltip error={error}>
        <TriangleAlert className="size-4 text-orange-500" />
      </ErrorTooltip>
    );

  return null;
};

export default AssetAlert;
